import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
const TrendTicker = () => {
  const { posts } = useSelector((state) => state.posts);
  const marqueeRef = useRef(null);

  useEffect(() => {
    if (!posts.length || !marqueeRef.current) return;

    const marqueeElement = marqueeRef.current;
    let animationId;
    let position = 0;
    const speed = 0.7;

    const animate = () => {
      position -= speed;
      const firstItemWidth = marqueeElement.firstChild.offsetWidth;
      if (Math.abs(position) >= firstItemWidth + 24) {
        position += firstItemWidth + 24;

        const firstItem = marqueeElement.firstChild;
        marqueeElement.appendChild(firstItem);
      }

      marqueeElement.style.transform = `translateX(${position}px)`;
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [posts]);

  // const handleScrollToMemberForm = () => {
  //   window.dispatchEvent(new Event("scrollToMemberForm"));
  // };

  return (
    <div className="hidden md:block bg-base-100 px-4 py-2 shadow-md">
      <div className="container flex items-center mx-auto px-4 max-w-[1200px]">
        <button
          className="btn btn-warning font-bold mr-3"
          // onClick={handleScrollToMemberForm}
        >
          TIN MỚI
        </button>
        <div className="relative flex-1 overflow-hidden text-sm">
          <div
            ref={marqueeRef}
            className="flex gap-6 whitespace-nowrap "
            style={{ willChange: "transform" }}
          >
            {posts.length > 0 &&
              [...posts, ...posts].map((news, index) => (
                <div
                  key={index}
                  className="font-medium inline-flex items-center "
                >
                  <Link to={`post/${news?.slug}`} className="hover:underline">
                    {news?.title}
                  </Link>

                  <span className="mx-4 text-gray-400">•</span>
                </div>
              ))}
          </div>
        </div>
        {/* Time */}
        <div className="text-sm text-gray-500 flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-5 h-6 pt-1"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 6v6l4 2m6-5a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>
            {new Date().toLocaleDateString("vi-VN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })}{" "}
            {new Date().getHours() % 12 || 12}:
            {String(new Date().getMinutes()).padStart(2, "0")}{" "}
            {new Date().getHours() >= 12 ? "Chiều" : "Sáng"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TrendTicker;
